import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import {FormattedMessage, injectIntl} from 'react-intl';
import Slide from '@material-ui/core/Slide';
import BaseButton from '../../../../components/button/BaseButton';
import DialogWrapper from '../../../../components/dialog/Dialog';
import {StudentStatus} from '../../../../constants/enums';
import {isMobile} from '../../../../utils/screenUtility';
import './manage.scss';

@injectIntl
@inject('inviteMemberStore')
@observer
class ResendLoginDialog extends Component {
    handleExited = () => {
        this.props.inviteMemberStore.setActiveUser(null);
    };

    render() {
        const {onClose, open, inviteMemberStore, intl: {formatMessage: translate}} = this.props;
        const dialogProps = {
            ...(isMobile() && {TransitionComponent: Slide}),
            TransitionProps: {direction: 'up'},
            classes: {root: 'resend-login-modal-root', paper: 'paper'},
            open: open,
            onExited: this.handleExited,
            onClose: onClose
        };
        const user = inviteMemberStore.activeUser || {};
        const userPendingStatus = user.status === StudentStatus.Invited;

        return (
            <DialogWrapper {...dialogProps}>
                <div className="resend-login-modal">
                    <h2 className="resend-login-title">
                        <FormattedMessage id={`manage.resend.${userPendingStatus ? 'login' : 'password'}.title`} />
                    </h2>
                    <p className="resend-login-message">
                        <FormattedMessage id="manage.resend.message" values={{email: user.email}} />
                    </p>
                    <BaseButton
                        className="resend-login-button"
                        label={translate({id: 'general.done'})}
                        onClick={onClose}
                    />
                </div>
            </DialogWrapper>
        );
    }
}

export default ResendLoginDialog;
